import {
  APIFieldErrors,
  isAPIErrorResponse,
  isAPIErrorResponseValue,
} from "./types";

export function formatMessage(status: number, statusText: string) {
  return `Request failed with status ${[status, statusText]
    .filter(Boolean)
    .join(": ")}`;
}

export function parseErrorField(
  errors: Record<string, unknown>,
  error: string,
  defaultValue = "-"
) {
  const errorValue = errors[error];

  if (typeof errorValue === "string") {
    return errorValue;
  }

  if (Array.isArray(errorValue)) {
    return errorValue.filter((e) => typeof e === "string")[0] || defaultValue;
  }

  return defaultValue;
}

export class APIError extends Error {
  status: number;
  statusText: string;
  errors: APIFieldErrors;
  detail?: string;

  constructor(status: number, statusText: string, body: unknown) {
    super(statusText);

    this.name = "APIError";
    this.status = status;
    this.statusText = statusText;
    this.message = formatMessage(status, statusText);
    this.detail = this.message;
    this.errors = {};

    if (isAPIErrorResponse(body)) {
      this.detail = body.detail;
      this.errors = body;
    } else if (isAPIErrorResponseValue(body)) {
      this.detail = Array.isArray(body) ? body[0] : body;
    }
  }
}
